<template>
  <footer role="contentinfo" class="usc-footer">
    <img class="logo" src="../assets/usc_marshall_footer_logo.svg" alt="USC Marshall School of Business logo" />
    <p>University of Southern California Marshall School of Business | Copyright 2001 - {{ new Date().getFullYear() }}</p>
    <router-link to="/sitemap" aria-label="Link to Sitemap">Sitemap</router-link>
    <a href="http://policy.usc.edu/info-privacy/" target="_blank">Privacy Policy</a>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
  props: [],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';

  .usc-footer {
    // background: url(../assets/sidebar_pattern.jpg);
    background: #232323;
    width: 100%;
    // height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    columns: #FFF;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 35px;
    padding-bottom: 35px;

    @media(min-width: $screen-sm-min) {
      padding-left: 50px;
      padding-right: 50px;
      z-index: 1;
    }

    @media(min-width: $screen-md-min) {
      padding-left: 370px;
    }

    img.logo {
      width: 165px;
      order: 1;
      flex-shrink: 0;
    }
    p {
      margin-bottom: 0;
      color: #FFF;
      order: 3;
      font-size: 15px;
      margin-top: 30px;
      width: 100%;
      text-align: center;
      @media(min-width: $screen-lg-min) {
        order: 2;
        width: auto;
        margin-top: 0;
      }
    }
    a {
      color: #FFF;
      text-decoration: none;
      order: 2;
      flex-shrink: 0;
      &:hover, &:focus {
        text-decoration: underline;
      }
      @media(min-width: $screen-lg-min) {
        order: 3;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue